<template>
    <div v-show="isActive" class="flex flex-col">
        <slot class="flex-1"></slot>
    </div>
</template>

<script>
export default {
  props: {
    name: { required: true },
    category: { required: false },
    selected: { default: false }
  },

  data() {
    return {
      isActive: false
    };
  },

  computed: {
    href() {
      const suffix = this.category ? this.category.id : Math.floor(Math.random() * 100);
      return "#" + this.name.toLowerCase().replace(/ /g, "-") + `-` + suffix;
    }
  },

  mounted() {
    this.isActive = this.selected;
  }
};
</script>

<style>
</style>
